import axios from 'axios';

// API Base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://app-rmmsapi.azurewebsites.net/api";

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add JWT token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('jwt_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('401 Unauthorized - Token expired or invalid');
      // Clear token and redirect to login
      sessionStorage.removeItem('jwt_token');
      // Optionally redirect to login
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth service functions
export const authService = {
  // Login and get token
  login: async (email, password, userId, companyId) => {
    const response = await axiosInstance.post('/Person/Generate_token', {
      email,
      password,
      userId: userId?.toString(),
      companyId: companyId?.toString()
    });

    if (response.data?.success && response.data?.token) {
      sessionStorage.setItem('jwt_token', response.data.token);
      return response.data;
    }
    throw new Error(response.data?.message || 'Token generation failed');
  },

  // Logout - clear token
  logout: () => {
    sessionStorage.removeItem('jwt_token');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!sessionStorage.getItem('jwt_token');
  },

  // Get stored token
  getToken: () => {
    return sessionStorage.getItem('jwt_token');
  }
};

export default axiosInstance;
